// extracted by mini-css-extract-plugin
module.exports = {"StartPage":"StartPage_StartPage__3b9qV","StartLink":"StartPage_StartLink__3o2LN"};